import { useRef } from 'react';

var usePrevious = function usePrevious(value) {
  var setInitialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var ref = useRef({
    target: value,
    previous: setInitialValue ? value : undefined
  });

  if (ref.current.target !== value) {
    ref.current.previous = ref.current.target;
    ref.current.target = value;
  }

  return ref.current.previous;
};

export { usePrevious };
